import styled from 'styled-components';

// Sized to match the other sidebar nav icons (16px).
const SidebarNavIconSvg = styled.svg`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--text-secondary);
`;

export default function SkillsIcon() {
  // Stacked blocks — represents the catalog of apps & skills.
  return (
    <SidebarNavIconSvg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <rect
        x="3"
        y="3"
        width="6"
        height="6"
        rx="1.4"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="11"
        y="3"
        width="6"
        height="6"
        rx="1.4"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="3"
        y="11"
        width="6"
        height="6"
        rx="1.4"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="11"
        y="11"
        width="6"
        height="6"
        rx="1.4"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </SidebarNavIconSvg>
  );
}
